import React from 'react'
import styled from 'styled-components'
import { Link } from 'react-static'

import Reveal from '../../common/Reveal'
import Loading from '../../common/Loading'
import HomeGalleryIcon from './HomeGalleryIcon'
import { gallery } from '../../../data/gallery'

const Wrapper = styled.section`
  position: relative;
  width: 100%;
  background-color: ${props => props.theme.main.bg};
  padding: 6em 25px;

  @media screen and (min-width: 801px) {
    padding: 4em 50px;
    display: flex;
    justify-content: center;
  }
`

const Inner = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-flow: column nowrap;
  text-align: center;

  h2 {
    color: #fff;
    display: block;
    margin: 0.5em auto 1em;
    font-size: 3.5em;
    text-shadow: 6px 6px 0 ${props => props.theme.secondary.bg3};
    transform: skewY(-13deg);
  }

  .icons-mobile {
    width: 100%;
  }

  .icons-desktop {
    display: none;
  }

  .home-gallery-icons {
    width: 100%;
    transform: skewY(-13deg);

    svg {
      transform: skewY(13deg);
    }
  }

  .home-gallery-menu-items {
    position: relative;
  }

  .home-gallery-icon-wrapper {
    width: 80%;
    padding: 0 1.5%;
    display: inline-block;
    margin-bottom: 1.5em;

    &:last-of-type {
      margin-bottom: 0;
    }
  }

  @media (min-width: 601px) and (max-width: 800px) {
    padding-bottom: 1em;

    h2 {
      font-size: 5em;
      margin: 0.4em auto 1em;
    }

    .home-gallery-icon-wrapper {
      width: 50%;
      padding: 0 4%;
      margin-bottom: 3em;

      &:nth-of-type(3),
      &:nth-of-type(4) {
        margin-bottom: 0;
      }
    }
  }

  @media screen and (min-width: 801px) {
    .icons-mobile {
      display: none;
    }

    .icons-desktop {
      display: block;
    }

    .home-gallery-menu-items {
      height: 20em;
      width: 20em;
      display: inline-block;
    }

    .home-gallery-header {
      width: 20em;
      height: 20em;
      position: absolute;
      left: 0;
      top: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      opacity: 0;

      &.visible {
        opacity: 1;
      }

      div {
        position: absolute;
        left: 1em;
        top: 0;
        width: 18em;
        height: 18em;
      }

      .home-gallery-header-inner {
        display: flex;
        justify-content: center;
        align-items: center;
        border: 2px solid #fff;
        border-radius: 100%;
        left: 0;
      }
    }

    h2 {
      font-size: 3.5em;
      margin: 0 auto;
    }

    .home-gallery-icons {
      width: 20em;
      height: 20em;
      margin: 0;
      transform: skewY(0deg);

      a {
        user-select: none;
        cursor: default;
      }

      .inner {
        transform: skewY(-13deg);
      }

      span {
        font-size: 2.5em;
      }

      svg {
        transform: skewY(13deg);

        & > * {
          stroke: ${props => props.theme.secondary.bg3};
        }

        & > .solid {
          fill: ${props => props.theme.secondary.bg3};
        }
      }
    }

    .home-gallery-icon-wrapper {
      margin-bottom: 3em;
      width: 100%;
      padding: 0 1em;
      position: absolute;
      left: 0;
      top: 0;
      visibility: hidden;

      &:nth-of-type(2) {
        margin-bottom: 0;
      }

      &.visible {
        visibility: visible;

        span {
          visibility: visible;
        }
      }
    }

    .home-gallery-cat {
      transition: color 0.2s ease;
      padding: 0.7em 0;
      display: inline-block;
      text-transform: capitalize;
      font-size: 1.2em;
      cursor: pointer;
      margin: 1em 0 0;
      border-bottom: 2px solid transparent;
      position: relative;
      padding: 0.5em 1em;

      &:after {
        position: absolute;
        content: '';
        left: 1em;
        bottom: -0.2em;
        width: calc(100% - 2em);
        height: 2px;
        background-color: transparent;
      }

      &.hover:after {
        background-color: #fff;
      }
    }
  }
`

class HomeGallery extends React.PureComponent {
  state = {
    titleVisible: true,
    iconVisible: gallery.map(x => 0),
  }

  handleCatEnter = this.handleCatEnter.bind(this)
  handleCatLeave = this.handleCatLeave.bind(this)
  renderDesktopIcons = this.renderDesktopIcons.bind(this)
  renderMobileIcons = this.renderMobileIcons.bind(this)

  handleCatEnter(e, current) {
    this.setState(prev => ({
      iconVisible: prev.iconVisible.map((x, i) => (i === current ? 1 : 0)),
      titleVisible: false,
    }))
  }

  handleCatLeave() {
    this.setState(prev => ({
      iconVisible: prev.iconVisible.map(x => 0),
      titleVisible: true,
    }))
  }

  renderDesktopIcons({ titleVisible, iconVisible }) {
    return (
      <div className="icons-desktop">
        <div className="home-gallery-menu-items">
          <div className={titleVisible ? 'home-gallery-header visible' : 'home-gallery-header'}>
            <Reveal>
              <div className="home-gallery-header-inner">
                <h2>GALLERY</h2>
              </div>
            </Reveal>
          </div>
          {gallery.length > 0 ? (
            <React.Fragment>
              <div className="home-gallery-icons">
                {gallery.map((item, i) => (
                  <div
                    key={item[0]}
                    className={
                      iconVisible[i]
                        ? 'home-gallery-icon-wrapper visible'
                        : 'home-gallery-icon-wrapper'
                    }
                  >
                    <HomeGalleryIcon cat={item[0]} />
                  </div>
                ))}
              </div>
            </React.Fragment>
          ) : (
            <Loading color="#fff" />
          )}
        </div>
        {gallery.length > 0 && (
          <Reveal className="home-gallery-cats">
            {gallery.map((item, i) => (
              <Link
                key={`cat-${item[0]}`}
                to={`gallery/${item[0]}`}
                className={iconVisible[i] ? 'home-gallery-cat hover' : 'home-gallery-cat'}
                onMouseEnter={e => this.handleCatEnter(e, i)}
                onMouseLeave={this.handleCatLeave}
              >
                {item[0]}
              </Link>
            ))}
          </Reveal>
        )}
      </div>
    )
  }

  renderMobileIcons() {
    return (
      <div className="icons-mobile">
        <div className="home-gallery-header">
          <Reveal>
            <h2>GALLERY</h2>
          </Reveal>
        </div>
        {gallery.length > 0 ? (
          <div className="home-gallery-icons">
            {gallery.map(item => (
              <Reveal key={item[0]} className="home-gallery-icon-wrapper">
                <HomeGalleryIcon cat={item[0]} />
              </Reveal>
            ))}
          </div>
        ) : (
          <Loading color="#fff" />
        )}
      </div>
    )
  }

  render() {
    const { mobile } = this.props
    const { titleVisible, iconVisible } = this.state

    return (
      <Wrapper>
        <Inner>
          {mobile
            ? this.renderMobileIcons()
            : this.renderDesktopIcons({ titleVisible, iconVisible })}
        </Inner>
      </Wrapper>
    )
  }
}

export default HomeGallery



// WEBPACK FOOTER //
// /opt/build/repo/src/components/pages/home/HomeGallery.js